import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const dashboardPath =
    user?.role === 'admin' ? '/admin'
    : user?.role === 'clinician' ? '/clinician'
    : user?.role === 'referral_partner' ? '/partner'
    : '/dashboard';

  return (
    <header className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand">
          <img src="/logo.svg" alt="GMW" className="navbar-logo" />Global Mind <span>Wellness Centre</span>
        </Link>

        <button className="navbar-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          <span /><span /><span />
        </button>

        <nav className={`navbar-links ${open ? 'open' : ''}`}>
          <a href="/#services" onClick={() => setOpen(false)}>Services</a>
          <a href="/#how-it-works" onClick={() => setOpen(false)}>How It Works</a>
          <a href="/#team" onClick={() => setOpen(false)}>Our Team</a>
          <a href="/#contact" onClick={() => setOpen(false)}>Contact</a>
          <Link to="/courses" onClick={() => setOpen(false)}>Courses</Link>

          {user ? (
            <>
              <Link to={dashboardPath} className="btn btn-secondary navbar-cta">Dashboard</Link>
              <button
                className="navbar-link-btn"
                onClick={() => { logout(); navigate('/'); }}
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)}>Log in</Link>
              <Link to="/book" className="btn btn-primary navbar-cta">Book Appointment</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
